import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 bi bi-image" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 bi bi-camera-video" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 bi bi-music-note-beamed" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 bi bi-paperclip" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "dz-message text-end align-items-center" }
const _hoisted_13 = { class: "svg-icon svg-icon-2hx svg-icon-info mx-auto" }
const _hoisted_14 = { class: "ms-4" }
const _hoisted_15 = { class: "fw-bold text-gray-600 mb-1" }
const _hoisted_16 = { class: "fw-semibold fs-6 text-muted" }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image fs-3" })
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "el-upload__tip d-none" }
const _hoisted_21 = { class: "d-flex flex-column mw-125px" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_FileViewer = _resolveComponent("FileViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      ref: "uploadRef",
      class: "upload-demo mb-5",
      action: _ctx.uploadActionUrl(),
      "on-error": _ctx.uploadErrorCallback,
      "on-success": _ctx.uploadFilesCallback,
      "on-progress": _ctx.onProgress,
      "auto-upload": true,
      disabled: _ctx.disabled,
      "show-file-list": false,
      accept: _ctx.acceptType
    }, {
      trigger: _withCtx(() => [
        (_ctx.type === 'multiBtn')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showRules.hasOwnProperty('image') ? _ctx.showRules.image : true)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    placement: "top",
                    effect: "light",
                    content: _ctx.translate('send image')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.acceptType = 'image/*'))
                      }, _hoisted_4)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true),
              (_ctx.showRules.hasOwnProperty('video') ? _ctx.showRules.video : true)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    placement: "top",
                    effect: "light",
                    content: _ctx.translate('send video')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.acceptType = 'video/*'))
                      }, _hoisted_6)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true),
              (_ctx.showRules.hasOwnProperty('voice') ? _ctx.showRules.voice : true)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 2,
                    placement: "top",
                    effect: "light",
                    content: _ctx.translate('send audio')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptType = 'audio/ogg, audio/opus'))
                      }, _hoisted_8)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true),
              (_ctx.showRules.hasOwnProperty('file') ? _ctx.showRules.file : true)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 3,
                    placement: "top",
                    effect: "light",
                    content: _ctx.translate('send file')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-custom btn-light border m-1 w-25px h-25px",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.acceptType = '*.*'))
                      }, _hoisted_10)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.type === 'btn')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["btn btn-sm btn-light btn-active-color-primary btn-hover-scale border border-dashed border-light text-nowrap", _ctx.disabled === true ? 'disabled' : '']),
                "data-kt-image-input-action": "change",
                "data-bs-toggle": "tooltip",
                title: _ctx.translate(_ctx.title)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi bi- fs-3", _ctx.icon])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.translate(_ctx.title)), 1)
              ], 10, _hoisted_11))
            : (_ctx.type === 'big')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["dropzone dz-clickable w-auto p-2", `${_ctx.classes}`]),
                  id: "kt_modal_create_project_settings_logo"
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_13, [
                        _createVNode(_component_inline_svg, { src: "/media/svg/files/upload.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.translate(_ctx.title)), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate("click to select file")) + ".", 1)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      ]),
      tip: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.translate("Please enter your file")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "me-3 d-none",
          type: "success",
          onClick: _ctx.submitUpload
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.translate("Send to server")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["action", "on-error", "on-success", "on-progress", "disabled", "accept"]),
    _createElementVNode("div", _hoisted_21, [
      (
          _ctx.uploading_status.uploadStatus &&
          _ctx.uploading_status.uploadStatus.percentage > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_el_progress, {
              "text-inside": true,
              "stroke-width": 15,
              percentage: Math.floor(_ctx.uploading_status.uploadStatus.percentage),
              status: 
            ['', 'success', 'exception', 'warning'].includes(
              _ctx.uploading_status.uploadStatus.status
            )
              ? _ctx.uploading_status.uploadStatus.status
              : ''
          ,
              striped: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.uploading_status.uploadStatus.name), 1)
              ]),
              _: 1
            }, 8, ["percentage", "status"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.uploading_status.uploadStatus.percentage === 100 ||
          (_ctx.file && _ctx.file.length > 10)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args))),
              class: "position-absolute translate-middle btn btn-icon w-20px h-20px btn-danger",
              style: {"margin-top":"17px"}
            }, _hoisted_25),
            (_openBlock(), _createBlock(_component_FileViewer, {
              file: _ctx.fileUrl ? _ctx.fileUrl : _ctx.uploadedFiles.url ,
              type: _ctx.uploadedFiles.file_type ? _ctx.uploadedFiles.file_type : _ctx.fileType,
              key: _ctx.uploadedFiles.url
            }, null, 8, ["file", "type"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}